import { createEvent } from "effector";
import { IResetPasswordStore, TEmailInput } from "./types";

export const setInputValue = createEvent<{ key: keyof TEmailInput, value: string }>();
export const confirmResetPassword = createEvent();
export const setSent = createEvent<boolean>();
export const tick = createEvent();
export const setResetPasswordsStore = createEvent<IResetPasswordStore>();
export const resetErrors = createEvent<keyof TEmailInput>();
